<template>
  <div v-if="value">
    <v-menu offset-y :nudge-right="10" style="width:100%" :max-height="400">
        <template v-slot:activator="{ on }">
        <div v-on="on" class="div-button rounded" style="display:flex">
            <img  class="round" width="30" height="30" :src="image" style="margin-right:8px;"/>
            <div style="line-height:1.5">
                <div style="xmargin-top:-5px;color:#888;font-size:9px;text-align:left;text-transform:uppercase">
                    {{label}}
                </div>
                <div style="margin-top:-4px;font-size:14px;">{{fullName(value)}}</div>
            </div>
        </div>
        </template>
        <v-list>
            <v-list-item v-for="user in users" :key="user.uid" @click="selectUser(user)">
                <v-list-item-avatar>
                    <img style="height:28px;width:28px" :src="user.image">
                </v-list-item-avatar>          
                <v-list-item-content>
                    <v-list-item-title>{{fullName(user)}}</v-list-item-title>
                </v-list-item-content>      
            </v-list-item>
        </v-list>
    </v-menu>
  </div>
  <div v-else>
    <v-menu offset-y :nudge-right="10" style="width:100%">
        <template v-slot:activator="{ on }">
        <div v-on="on" class="div-button rounded display-flex">
            <v-icon large color="grey lighten-2" style="margin-right:8px;">account_circle</v-icon>
            <div style="margin-top:5px;color:#888">
                {{label}}
            </div>
        </div>
        </template>
        <v-list>
            <v-list-item v-for="user in users" :key="user.uid" @click="selectUser(user)">
                <v-list-item-avatar>
                    <img style="height:28px;width:28px" :src="user.image">
                </v-list-item-avatar>                
                <v-list-item-title>{{fullName(user)}}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
  </div>
</template>

<script>
// 
import ContactHelpers from '../helpers/ContactHelpers'
import ContactData from '../data/ContactData'


    export default {
        props: ['contact', 'contacts', 'value', 'role', 'label'],
        data() {
            return {
                localUsers: []   
            }
        },
        watch: {

        },
        computed: {
            users() {
                let users
                if(this.contacts)
                    users = this.contacts
                else
                    users = this.localUsers
                return users.sort( (a,b) => a.firstName > b.firstName)
            },
            image() {
                if(this.value && this.value.image)
                    return this.value.image
                else
                    return ''
            }

        },

        methods: {
            selectUser (user) {
                console.log('selectUser in Userchooser', user)
                this.$emit('input', user)
                this.$emit('select', user)
            },

            fullName(user) {
                return ContactHelpers.fullName(user)
            }
          
        },
        created () {

            if(!this.contacts) {
                ContactData.fetchContactsForRole(this.role).then(contacts => {
                    this.localUsers = contacts.sort( (a,b) => a.firstName > b.firstName)
                })
            }
            
        }
    }
</script>

<style>

</style>    


// WEBPACK FOOTER //
// UserChooser.vue?47bb828c